import { useState } from 'react';
import { Button, Paper } from '@insio/ui-toolkit';
import { useFeatureTranslation } from '@/hooks/useFeatureTranslation';
import { DeclareMasterAccountModal } from './DeclareMasterAccountModal';

/** Lets an ADMIN declare a direct-customer account a master account, after a confirmation. */
export function MasterAccountToggleSection() {
  const t = useFeatureTranslation('systemSettings.organization');
  const [declareOpen, setDeclareOpen] = useState(false);

  return (
    <Paper showDivider={false} padding='none'>
      <Paper.Content className='p-md'>
        <div className='flex flex-wrap items-center justify-between gap-md'>
          <div className='space-y-2xs'>
            <p className='font-medium text-foreground-base'>{t('masterAccountSection.title')}</p>
            <p className='text-sm text-foreground-muted'>{t('masterAccountSection.description')}</p>
          </div>
          <Button
            variant='default'
            outline='default'
            icon='briefcase'
            testId='declare-master-account'
            onClick={() => setDeclareOpen(true)}
          >
            {t('masterAccountSection.action')}
          </Button>
        </div>
      </Paper.Content>

      <DeclareMasterAccountModal open={declareOpen} onClose={() => setDeclareOpen(false)} />
    </Paper>
  );
}
